<template>
  <div class="demand">
    <el-tabs v-model="activeName" class="orderListTabs">
      <el-tab-pane
        v-for="item in tabList"
        :key="item.id"
        :label="item.name"
        :name="item.id"
      >
      </el-tab-pane>
    </el-tabs>
    <!-- <div v-show="activeName == 0">
      <div class="searchPart">
        <el-input v-model="orderName" placeholder="订单名称"></el-input>
        <el-input v-model="orderNumber" placeholder="订单编号"></el-input>
        <el-select v-model="orderType" placeholder="订单来源">
          <el-option label="草稿" value="DRAFT"> </el-option>
          <el-option label="待审核" value="AUDIT"> </el-option>
          <el-option label="审核通过" value="PASS"> </el-option>
          <el-option label="审核拒绝" value="REJECT"> </el-option>
        </el-select>
        <el-date-picker
          v-model="orderTime"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="下单时间"
        >
        </el-date-picker>
        <el-button class="searchBtn" @click="search">搜索</el-button>
        <el-button type="text" class="resetBtn" @click="reset">
          <i class="iconfont icon-qingchushujuku"></i>
          <span>清除条件</span>
        </el-button>
      </div>
      <div class="tablePart">
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          class="tableContent"
        >
          <el-table-column
            prop="orderNum"
            label="订单编号"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="orderName"
            label="订单名称"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <div class="ordernameClass">
                <img :src="scope.row.imgs" alt="" />
                <p>{{ scope.row.orderName }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="complaintObj"
            label="订单来源"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="complaintState"
            label="联系客服"
            header-align="center"
            align="center"
            width="110"
          >
            <template slot-scope="scope">
              <div class="imgIcon">
                <img :src="scope.row.complaintState" alt="" width="20px" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="complaintTime"
            label="下单时间"
            header-align="center"
            align="center"
            width="110"
          >
          </el-table-column>

          <el-table-column
            label="操作"
            header-align="center"
            align="center"
            width="230"
          >
            <template slot-scope="scope">
              <el-button type="text" size="small">申请售后</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @current-change="handleCurrentChange"
          @prev-click="handleCurrentChange"
          @next-click="handleCurrentChange"
          layout="total,prev, pager, next,jumper"
          :current-page="pageNo"
          :page-size="pageSize"
          :total="total"
          class="pagination"
        >
        </el-pagination>
      </div>
    </div> -->
    <after-sales-record v-show="activeName == 1"></after-sales-record>
    <after-sales-refund v-show="activeName == 2"></after-sales-refund>
  </div>
</template>

<script>
import afterSalesRecord from "./afterSalesRecord";
import afterSalesRefund from "./afterSalesRefund";

import { mapState, mapMutations } from "vuex";

export default {
  components: {
    afterSalesRecord,
    afterSalesRefund
  },
  data() {
    return {
      orderName: "",
      orderNumber: "",
      orderType: "",
      orderTime: "",
      activeName: "1",
      tabList: [
        // {
        //   id: "0",
        //   name: "申请售后",
        // },
        {
          id: "1",
          name: "售后记录",
        },
        {
          id: "2",
          name: "退款明细",
        },
      ],
      tableData: [
        {
          orderNum: "3DSC20210824001",
          imgs: "",
          orderName: "3D打印机",
          complaintObj: "3D商城",
          complaintState: require("../../assets/images/weChats.jpeg"),
          complaintTime: "2021-08-24",
        },
      ],
      pageNo: 0,
      pageSize: 10,
      total: 1000,
      demandSelection: [],
    };
  },
  computed: {
    ...mapState({}),
  },
  created() {},
  methods: {
    // 清除检索条件
    reset() {
      this.orderName = "";
      this.orderNumber = "";
      this.orderType = "";
      this.orderTime = "";
    },
    // 分页
    handleCurrentChange(val) {
      this.pageNo = val;
    },
    search() {},
    publishSubmit() {},
  },
};
</script>

<style scoped lang="less">
.demand {
  padding: 20px;
  .orderListTabs {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 999;
    background: #fff;
    width: 100%;
    padding: 20px;
  }
  .releaseBox {
    background: #fff;
    padding: 35px;
    padding-top: 0;
    box-sizing: border-box;
    .releaseBoxTop {
      margin-bottom: 15px;
      h4 {
        font-size: 18px;
        color: #157efa;
        margin-bottom: 18px;
      }
      .releaseBoxTopInput {
        font-size: 14px;
        color: #262626;
        align-items: center;
        margin-bottom: 20px;
        /deep/.ql-toolbar.ql-snow {
          display: none;
        }
        /deep/.ql-toolbar.ql-snow + .ql-container.ql-snow {
          border-top: 1px solid #ccc;
        }
        .releaseBoxTopInputBox {
          flex-wrap: wrap;
        }
        input {
          height: 30px;
          background: #f5f5f5;
          border-radius: 4px;
          border: none;
          padding-left: 8px;
          box-sizing: border-box;
        }
        .input2 {
          width: 161px;
          // margin-left: 90px;
        }
        textarea {
          width: 614px;
          height: 206px;
          background: #f5f5f5;
          opacity: 1;
          border-radius: 6px;
          border: none;
          padding: 8px;
          box-sizing: border-box;
        }
        /deep/.el-input--prefix .el-input__inner {
          width: 161px;
          height: 30px;
          background: #f5f5f5;
          border-radius: 4px;
          border: none;
          //   padding-left: 8px;
          box-sizing: border-box;
          //   margin-left: 25px;
        }
        // /deep/.el-input__prefix {
        //   right: -132px;
        //   left: 0;
        // }
        /deep/.el-input__icon {
          line-height: 30px;
        }
        .releaseBoxbotInputP {
          width: 94px;
          flex-shrink: 0;
          white-space: nowrap;
        }
        .releaseBut {
          background: #157efb;
          color: #fff;
        }
        button {
          width: 100px;
          height: 30px;
          background: #f5f5f5;
          border-radius: 4px;
          border: none;
          margin-right: 20px;
          color: #262626;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
  }

  .searchPart {
    display: flex;
    flex-wrap: wrap;
    margin-top: 83px;

    /deep/ .el-input {
      width: initial;
      margin-bottom: 22px;
      margin-right: 30px;
    }

    /deep/ .el-input__inner {
      width: 242px;
      height: 35px;
      min-height: 35px;
      font-size: 12px;
      color: #999999;
      background-color: #f2f4f7;
      border: 1px solid #f2f4f7;
      border-radius: 5px;

      &:hover,
      &:focus {
        background-color: #fff;
        border: 1px solid #108ee9;
      }
    }

    /deep/ .el-input__prefix {
      top: -3px;
    }

    /deep/ .el-input__suffix {
      top: 2px;
    }

    /deep/ .el-button {
      display: block;
      line-height: 35px;
      padding: 0;
      height: 35px;
    }

    .searchBtn {
      width: 82px;
      background: #3d7fff;
      border: none;
      border-radius: 15px;
      font-size: 14px;
      color: #ffffff;
      margin-bottom: 22px;
    }

    .resetBtn {
      color: #333333;
      margin-bottom: 22px;
    }
  }

  .tablePart {
    .ordernameClass {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        margin-right: 10px;
      }
    }
    .imgIcon {
      img {
        width: 20px !important;
        height: 20px !important;
      }
    }
    .tableTool {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      .toolLeft {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.847);

        .num {
          color: #356fdf;
        }

        button {
          padding: 0;
          margin-left: 15px;
          width: 80px;
          height: 30px;
          background: rgba(242, 244, 247, 1);
          box-sizing: border-box;
          border: 1px solid rgba(21, 126, 251, 1);
          border-radius: 5px;
          font-size: 12px;
          color: #157efb;
          line-height: 30px;
          text-align: center;

          &:hover {
            background: #157efb;
            box-sizing: border-box;
            border: 1px solid #157efb;
            color: #fff;
          }
        }
      }

      .toolRight {
        button {
          width: 83px;
          height: 30px;
          background: rgba(21, 126, 251, 1);
          border: none;
          border-radius: 15px;
          font-size: 13px;
          color: #fff;

          i {
            padding-right: 5px;
          }

          &:hover {
            background: #61a2f0;
          }
        }
      }
    }

    .tableContent {
      min-height: 650px;

      /deep/ .el-table__header {
        tr {
          th {
            border-right: none;
          }
        }

        /deep/ .el-table__cell {
          padding: 5px 0;
          background: #f2f5fc;
        }
      }

      /deep/ .el-table__body {
        img {
          vertical-align: middle;
          width: 52px;
          height: 50px;
        }

        /deep/ .el-table__row {
          td:first-child {
            border-right: none;

            .cell {
              padding-left: 15px;
            }
          }
        }
      }
    }

    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
/deep/.el-dialog__body {
  padding-top: 0;
}
.itemFlex {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  .name {
    margin-left: 10px;
    /deep/p {
      margin: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/service/afterSalesService.vue